import { CaretLeft, CaretRight } from '@phosphor-icons/react'

import * as Styles from './styles'

const TableHorizontalScrollArrows = ({ onClickInArrow, showLeftArrow, showRightArrow }) => {
  return (
    <>
      {showLeftArrow && (
        <Styles.ArrowLeftContainer onClick={() => onClickInArrow('left')}>
          <CaretLeft alt="left" />
        </Styles.ArrowLeftContainer>
      )}
      {showRightArrow && (
        <Styles.ArrowRightContainer onClick={() => onClickInArrow('right')}>
          <CaretRight alt="right" />
        </Styles.ArrowRightContainer>
      )}
    </>
  )
}

export default TableHorizontalScrollArrows
